import React, { FC } from 'react';

import { IIconType } from './types';

export const IconRemoveMinus: FC<IIconType> = ({ color = 'black', size = '16' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.25 7.5H11.75"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
